'use client';

import React from 'react';
import { Button } from 'src/components';

interface AddToListSectionProps {
  selectedProviders: any[];
  handleAddToLists: () => void;
}

const AddToListSection: React.FC<AddToListSectionProps> = ({
  selectedProviders,
  handleAddToLists,
}) => {
  if (!selectedProviders || selectedProviders.length === 0) {
    return null;
  }

  return (
    <div className="w-full h-14 px-4 py-4 inline-flex justify-between items-center border-t border-neutral-200 bg-white">
      <Button
        onClick={handleAddToLists}
        className="w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold rounded-full"
      >
        {`Add ${selectedProviders.length} ${
          selectedProviders.length > 1 ? 'Providers' : 'Provider'
        } to List`}
      </Button>
    </div>
  );
};

export default AddToListSection;
